import { API } from 'constants/api-endpoints';
import { MULTIPART_HEADER } from 'constants/request-config';

import { tokenInstance } from 'lib/axios/instance';

export const updateTeamInfo = async (teamId, formData) => {
  await tokenInstance.post(`${API.TEAM}/${teamId}`, formData, MULTIPART_HEADER);
};
